export default "__VITE_ASSET__gPmNEg$___"